var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPyrposeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1F6631"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8675 12.6401C23.4259 16.1279 20.1323 22.1782 20.1323 28.6826V41L22.2667 39.4969C26.3615 36.6144 28.7038 31.5547 28.7038 28.5141L28.4038 28.2561C26.7774 26.8596 26.9684 24.273 28.7822 23.1345C33.3407 20.2108 36.1024 15.1407 36.1024 9.69231V8L28.8675 12.6401Z",
    fill: "url(#paint0_linear_3454_1166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5435 30.0929C28.6458 29.656 28.7037 28.5141 28.7037 28.5141C28.7037 22.0097 25.5056 16.1279 20.0641 12.6366L12.8291 8V9.70607C12.8291 15.1476 15.5874 20.2108 20.1391 23.1276L27.0842 27.3996C27.0842 27.3996 28.7583 28.4006 28.5435 30.0894V30.0929Z",
    fill: "url(#paint1_linear_3454_1166)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    },
    opacity: 0.15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8675 12.6401C23.4259 16.1279 20.1323 22.1782 20.1323 28.6826V41L22.2667 39.4969C26.3615 36.6144 28.7038 31.5547 28.7038 28.5141L28.4038 28.2561C26.7774 26.8596 26.9684 24.273 28.7822 23.1345C33.3407 20.2108 36.1024 15.1407 36.1024 9.69231V8L28.8675 12.6401Z",
    fill: "url(#paint2_linear_3454_1166)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5435 30.0929C28.6458 29.656 28.7037 28.5141 28.7037 28.5141C28.7037 22.0097 25.5056 16.1279 20.0641 12.6366L12.8291 8V9.70607C12.8291 15.1476 15.5874 20.2108 20.1391 23.1276L27.0842 27.3996C27.0842 27.3996 28.7583 28.4006 28.5435 30.0894V30.0929Z",
    fill: "url(#paint3_linear_3454_1166)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3454_1166",
    x1: 38.5948,
    y1: 10.1085,
    x2: 14.7374,
    y2: 36.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E0B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338368,
    stopColor: "#8EE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504563,
    stopColor: "#5EC968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579971,
    stopColor: "#4DAC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732658,
    stopColor: "#7CE186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99EBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3454_1166",
    x1: 17.4183,
    y1: 22.1956,
    x2: 24.87,
    y2: 16.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#60D26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#89E5A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3454_1166",
    x1: 38.5948,
    y1: 10.1085,
    x2: 14.7374,
    y2: 36.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E0B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338368,
    stopColor: "#8EE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504563,
    stopColor: "#5EC968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579971,
    stopColor: "#4DAC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732658,
    stopColor: "#7CE186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99EBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3454_1166",
    x1: 17.4183,
    y1: 22.1956,
    x2: 24.87,
    y2: 16.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#60D26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#89E5A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyrposeCard);
export default __webpack_public_path__ + "static/media/pyrpose-card.78760e56bfa92c93746f4ce8ac450f38.svg";
export { ForwardRef as ReactComponent };